import moment, { Moment } from 'moment';

export const nullStringToNullMoment = (value: string | null) =>
  value ? moment(value) : null;
export const nullMomentToNullString = (moment: Moment | null) =>
  moment ? moment.toJSON() : null;

export const rangeAdapterStringToMoment = (
  params: [string, string] | undefined,
): [Moment | null, Moment | null] | null =>
  params
    ? [
        params[0] ? moment(params[0]) : null,
        params[1] ? moment(params[1]) : null,
      ]
    : null;

export const rangeAdapterMomentToString = (
  params: [Moment | null, Moment | null] | null,
): [string | null, string | null] | null =>
  params
    ? [
        params[0] ? params[0].toJSON() : null,
        params[1] ? params[1].toJSON() : null,
      ]
    : null;
